import { render } from "./datepicker.vue?vue&type=template&id=3758a795&ts=true"
import script from "./datepicker.vue?vue&type=script&lang=ts"
export * from "./datepicker.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__